import { CircleAlert, TriangleAlert } from '@orgus/ui/icons';
import type { ReactNode } from 'react';
import { cn } from '@orgus/ui';

/**
 * A quiet banner for a partial state: something is missing or held, the rest still works
 * (no verify command yet, waiting for a machine, an environment frozen).
 */
export function Notice({ tone = 'waiting', title, children, action, className }: { tone?: 'waiting' | 'neutral'; title: ReactNode; children?: ReactNode; action?: ReactNode; className?: string }) {
  const Icon = tone === 'waiting' ? TriangleAlert : CircleAlert;
  return (
    <div
      role="status"
      className={cn(
        'flex items-start gap-3 rounded-card border px-4 py-2 text-ui',
        tone === 'waiting' ? 'border-status-attention-line bg-status-attention-soft' : 'border-border bg-surface',
        className,
      )}
    >
      <span className="flex h-5 shrink-0 items-center">
        <Icon className={cn('size-4', tone === 'waiting' ? 'text-status-attention' : 'text-fg-subtle')} aria-hidden />
      </span>
      <p className="min-w-0 flex-1 text-fg">
        <span className="font-medium">{title}</span> {children && <span className="text-fg-muted">{children}</span>}
      </p>
      {action}
    </div>
  );
}
